<template>
  <svg class="icon icon--file" width="21px" height="26px" viewBox="0 0 21 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g class="Inspiration-Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
       transform="translate(-12.000000, -9.000000)">
      <g class="Group" transform="translate(13.000000, 10.000000)" stroke="#FFFFFF" stroke-width="1.5">
        <polyline class="Shape" stroke-linecap="square" points="19 8 12 8 12 1"></polyline>
        <polygon class="Shape" stroke-linecap="square"
                 points="12.2436925 0.0106856634 0 0 0 24 18.9887207 24 19 6.03739982"></polygon>
        <polygon class="Path-2" points="4 20 4 12 15 12 15 20"></polygon>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/File.vue